export default "__VITE_PUBLIC_ASSET__d38aa75a__"